import React from 'react';

const RestaurantDailySalesReportHeader = () => (
    <h1>Daily Sales Report</h1>
);

export default RestaurantDailySalesReportHeader;
